import React from "react";
import { NavLink } from "react-router-dom";
import { Div } from "../../../../components/core/03-base/Div";
import { FlexRow } from "../../../../components/core/03-base/Flex/Row";
import { Button } from "../../../../components/core/05-atoms/Button";
import { ThemePalette, ThemeShadowSizes } from "../../../../theme/_Types";
export var StepsHeader = function (props) { return (React.createElement(FlexRow, { isFixed: true, style: { zIndex: 1 } },
    React.createElement(Div, { theme: {
            padding: {
                "": { y: 1, x: 3 },
                "sm": { y: 1, x: 3 },
            },
            palette: ThemePalette.CONTRAST_PRIMARY,
            shadow: ThemeShadowSizes.SMALL,
        }, style: { minHeight: "32px", minWidth: "100%" } },
        React.createElement(Div, { style: { display: "flex", flexDirection: "row" } },
            (props.goBack || !!props.goBackHistory) &&
                React.createElement(Div, { style: { flex: 1, flexGrow: 0 }, theme: {
                        padding: {
                            "": { r: 2 },
                            "sm": { r: 3 },
                        },
                    } }, !props.goBackHistory && props.goBack ? (React.createElement(NavLink, { to: props.goBack, exact: true },
                    React.createElement(Button, { icon: "chevron-left", theme: { palette: ThemePalette.BRAND_ACCENT } }))) : (React.createElement(Button, { icon: "chevron-left", theme: { palette: ThemePalette.BRAND_ACCENT }, link: { onClick: function () { return window.history.back(); } } }))),
            React.createElement(Div, { style: { flex: 1, alignSelf: "center" } },
                (props.goBack || !!props.goBackHistory) ?
                    React.createElement("h3", { className: "scl-b-h scl-b-h6" }, props.title)
                    :
                        React.createElement("h1", { className: props.hasSmallTitle ? "scl-b-h scl-b-h6" : "scl-b-h scl-b-h2", style: props.hasSmallTitle ? { lineHeight: "54px" } : {} }, props.title),
                props.description &&
                    React.createElement(Div, null,
                        React.createElement("p", { className: "scl-mono-font-size" }, props.description))),
            props.children)))); };
